import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import './DefaultHeader.css';

function DefaultHeader(props) {

    const navigate = (route) => {
        setDropdownOpen(false)
        props.history.push(route);
    }

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(prevState => !prevState);

    let pathname = props.location.pathname;

    return (
        <div className="web-header hide-on-print">
            <nav className="navbar navbar-expand-lg">
                <div className="container-fluid headerContainer">
                    <span onClick={() => navigate('/PurchaseOrders')} className="navbar-brand pointer me-lg-auto">
                        <img alt="logo" src={require('../../assets/images/4warranty-log.png').default} />
                    </span>
                    <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#NavMain" aria-controls="NavMain" aria-expanded="false" aria-label="Toggle navigation">
                        <span> </span>
                        <span> </span>
                        <span> </span>
                    </button>

                    <div className="collapse navbar-collapse mr-20" id="NavMain">
                        <ul className="navbar-nav">

                            <li className="nav-item pointer headerDropdown headerPO" > <Dropdown isOpen={dropdownOpen} onMouseOver={() => setDropdownOpen(true)} onMouseLeave={() => setDropdownOpen(false)} toggle={toggle}>
                                <DropdownToggle onClick={() => navigate('PurchaseOrders')} caret className={`nav-link ${pathname === '/PurchaseOrderDetails' || pathname === '/PurchaseOrders' || pathname === '/PurchaseOrderReport' ? 'active' : ''}`} > PURCHASE ORDERS
                                </DropdownToggle>
                                <DropdownMenu onMouseOver={() => setDropdownOpen(true)}>
                                    <DropdownItem text> <div onClick={() => navigate('PurchaseOrders')} >PO INQUIRY SEARCH</div></DropdownItem>

                                    <DropdownItem text><div onClick={() => navigate('PurchaseOrderReport')} >PO STATUS REPORT</div></DropdownItem>
                                </DropdownMenu>
                            </Dropdown></li>

                            <li onClick={() => navigate('Claims')} className="nav-item pointer">
                                <span className={`nav-link ${pathname === '/ClaimDetails' || pathname === '/Claims' ? 'active' : ''}`}>CLAIM INQUIRY</span>
                            </li>
                            <li onClick={() => navigate('ClaimReport')} className="nav-item pointer beforeLogoutHeader">
                                <span className={`nav-link  ${pathname === '/ClaimReport' ? 'active' : ''}`}>CLAIM REPORT</span>
                            </li>


                            <li style={{ position: "absolute", right: "20px" }} onClick={() => navigate('/')} className="nav-item pointer">
                                <span className="nav-link">LOGOUT</span>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default withRouter(DefaultHeader);